
/**
 * Internal dependencies
 */
import {
    BARCODE_LOOKUP_PLANS_RECEIVE,
    BARCODE_LOOKUP_PLANS_REQUEST,
    BARCODE_LOOKUP_PLANS_REQUEST_SUCCESS,
    BARCODE_LOOKUPPLANS_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import { getAllBarcodeLookupPlans, requestingBarcodeLookupPlans } from './selectors';

/**
 * [description]
 * 
 * @param  {Function}   [description]
 * @return {[type]}                  [description]
 */
export const requestBarcodeLookupPlans = () => (dispatch) => {
    dispatch({
        type: BARCODE_LOOKUP_PLANS_REQUEST
    });

    return cscom.barcodeLookupPlan().list()
        .then(barcodeLookupPlans => {
            dispatch({
                type: BARCODE_LOOKUP_PLANS_REQUEST_SUCCESS
            });
            dispatch({
                type: BARCODE_LOOKUP_PLANS_RECEIVE,
                payload: {
                    items: barcodeLookupPlans
                }
            });
            return barcodeLookupPlans
        }); 
}

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestPlansIfNotRequested = (...props) => async (dispatch, getState) => {
	
	const plans = getAllBarcodeLookupPlans(getState());
	const requesting = requestingBarcodeLookupPlans(getState());

	if (plans.length === 0 && requesting === false) {
		return dispatch(requestBarcodeLookupPlans(...props))
	}

	return plans;
}